(function () {
  if (window.__sideCartEnhancementsBound) return;
  window.__sideCartEnhancementsBound = true;

  function getCartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function addToCartViaForm(form, button) {
    if (!form || (button && button.getAttribute('aria-disabled') === 'true')) return;

    var cartDrawer = getCartDrawer();
    var originalHtml = button ? button.innerHTML : '';
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.innerHTML = 'Adicionando...';
    }

    var formData = new FormData(form);
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }
    }

    var addUrl =
      (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (!/\.js$/.test(addUrl)) addUrl += '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (button) {
          button.innerHTML = originalHtml;
          button.removeAttribute('aria-disabled');
        }

        if (payload.status && (payload.description || payload.message)) {
          return;
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
          cartDrawer.renderContents(payload);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (button) {
          button.innerHTML = originalHtml;
          button.removeAttribute('aria-disabled');
        }
        form.submit();
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('form.side-cart-upsell__form, form.side-combina-form');
      if (!form) return;
      event.preventDefault();
      addToCartViaForm(form, form.querySelector('[type="submit"]'));
    },
    true
  );
})();
